export default __webpack_public_path__ + "static/media/1.71baf4b1.jpg";